import axios from 'axios';
import { appConfig } from '../tools/AppConfig';

export const pay = (nationalId, token) => {
  return axios
    .post(appConfig.getServerUrl() + `/api/acceptance/payments/pay`, {
      source: {
        identifier: nationalId,
        subtype: 'HALAN',
      },
      payment_token: token,
    })
    .then((res) => res)
    .catch((err) => err && err.response);
};

export const sendOTP = (planId, transactionId, token) => {
  return axios
    .post(appConfig.getServerUrl() + `/api/acceptance/halan/send_otp`, {
      chosen_plan_id: planId,
      transaction_id: transactionId,
      payment_token: token,
    })
    .then((res) => res)
    .catch((err) => err && err.response);
};

export const confirmOTP = (otp, transactionId, token) => {
  return axios
    .post(appConfig.getServerUrl() + `/api/acceptance/halan/confirm_otp`, {
      otp: otp,
      transaction_id: transactionId,
      payment_token: token,
    })
    .then((res) => res)
    .catch((err) => err && err.response);
};
